export const CLOSED_SALES_STATUSES = {
  none: 'none', // нет подписки
  active: 'active', // подписка активна
  cancelled: 'cancelled', // отмена подписки
  dismissed: 'dismissed', // подписка не интересна
} as const;

export const CANCEL_TYPES = {
  cancel: 'cancel',
  dismiss: 'dismiss',
} as const;
